{
  "search": {
    "search": "Search",
    "openSearch": "Open Search",
    "referenceSearch": "Reference Search",
    "referenceSearchResults": "Reference Search Results",
    "path": "Path:",
    "description": "Description:",
    "deprecated": "Deprecated",
    "httpMethod": "HTTP Method:",
    "required": "REQUIRED",
    "optional": "optional",
    "tagGroup": "Tag Group",
    "navigate": "Navigate",
    "select": "Select",
    "keyboardShortcut": "Keyboard Shortcut:",
    "command": "Command",
    "ctrl": "CTRL",
    "instructions": "Press up arrow / down arrow to navigate, enter to select, type to filter results",
    "entryTypes": {
      "heading": "Heading",
      "operation": "Operation",
      "tag": "Tag",
      "model": "Model",
      "webhook": "Webhook"
    }
  },
  "agent": {
    "askAi": "Ask AI",
    "askAiAgent": "Ask AI Agent",
    "closeClient": "Close Client"
  },
  "common": {
    "copyLink": "Copy link",
    "copyLinkTo": "Copy link to {label}",
    "termsOfService": "Terms of Service",
    "authentication": "Authentication",
    "introduction": "Introduction",
    "server": "Server:",
    "selectServer": "Select a server",
    "default": "Default",
    "example": "Example",
    "examples": "Examples",
    "type": "Type:",
    "format": "Format:",
    "pattern": "Pattern:",
    "models": "Models",
    "operations": "Operations",
    "webhook": "Webhook",
    "webhooks": "Webhooks",
    "headers": "Headers",
    "cookies": "Cookies",
    "body": "Body",
    "requestBody": "Request Body",
    "responses": "Responses",
    "required": "required",
    "deprecated": "deprecated",
    "additionalProperties": "additional properties",
    "const": "const:",
    "nullable": "nullable",
    "writeOnly": "write-only",
    "readOnly": "read-only",
    "enum": "enum",
    "emptyObject": "Empty object",
    "collapsed": "Collapsed",
    "showSchema": "Show Schema",
    "status": "Status:",
    "noBody": "No Body",
    "selectedContentType": "Selected Content Type:",
    "testRequest": "Test Request",
    "downloadOpenApiDocument": "Download OpenAPI Document",
    "more": "More",
    "selectFromAllClients": "Select from all clients",
    "fileFormatJson": "json",
    "fileFormatYaml": "yaml",
    "showMore": "Show More",
    "openMenu": "Open Menu",
    "closeMenu": "Close Menu",
    "sidebarFor": "Sidebar for {title}",
    "openApiDocumentationFor": "Open API Documentation for {title}",
    "endpointsForTag": "{tag} endpoints",
    "showAllEndpoints": "Show all {tag} endpoints"
  },
  "operation": {
    "pathParameters": "Path Parameters",
    "queryParameters": "Query Parameters",
    "description": "Operation Description",
    "copyEndpointUrl": "Copy endpoint URL",
    "callbacks": "Callbacks",
    "showHeaders": "Show Headers",
    "hideHeaders": "Hide Headers",
    "showAdditionalProperties": "Show additional properties",
    "childAttributes": "Child Attributes",
    "showChildAttributes": "Show {name}",
    "hideChildAttributes": "Hide {name}"
  },
  "schema": {
    "unknownType": "unknown type"
  },
  "language": {
    "selectLanguage": "Select language"
  },
  "developerTools": {
    "title": "Developer Tools",
    "titleDescription": "The developer tools allow you to customize the appearance and behavior of your documentation. You can also share your documentation using the Scalar Registry.",
    "disableToolbarPrefix": "To disable the toolbar, set",
    "disableToolbarSuffix": "in your configuration.",
    "copyToClipboard": "Copy link to clipboard",
    "localhostOnly": "The developer tools will only appear when running on localhost.",
    "configure": "Configure",
    "scalarConfiguration": "Scalar Configuration",
    "theme": "Theme",
    "layout": "Layout",
    "layoutOptions": "Layout Options",
    "share": "Share",
    "shareApiReference": "Share your API Reference",
    "shareDescription": "Upload your OpenAPI document to share your API Reference with others. As easy as pressing a button.",
    "deploy": "Deploy",
    "scalarDocs": "Scalar Docs",
    "deployDescription": "Deploy your documentation on Scalar, the modern documentation platform for your API and everything else.",
    "generate": "Generate",
    "deployOnScalar": "Deploy on Scalar",
    "deployForFree": "Deploy your documentation for free.",
    "additionalFeaturesMightRequire": "Additional features might require",
    "scalarPro": "Scalar Pro",
    "uploadDocument": "Upload Document",
    "temporaryLinkExpiry": "Your document will automatically be deleted after 7 days.",
    "unableToExportActiveDocument": "Unable to export active document",
    "unknownError": "An unknown error occurred",
    "generateMcp": "Generate MCP",
    "connectMcp": "Connect MCP",
    "showSidebar": "Show Sidebar",
    "defaultOpenFirstTag": "Default Open First Tag",
    "defaultOpenAllTags": "Default Open All Tags",
    "expandAllModelSections": "Expand All Model Sections",
    "expandAllResponses": "Expand All Responses",
    "hideClientButton": "Hide Client Button",
    "hideDarkModeToggle": "Hide Dark Mode Toggle",
    "hideModels": "Hide Models",
    "hideSearch": "Hide Search",
    "showOperationId": "Show Operation ID",
    "hideTestRequestButton": "Hide Test Request Button",
    "passwordProtection": "Password Protection",
    "customDomains": "Custom Domains",
    "freeFormContent": "Free-form content",
    "cdnInfrastructure": "CDN Infrastructure",
    "pullFromGithub": "Pull from GitHub",
    "markdownMdx": "Markdown/MDX",
    "spectralLinting": "Spectral Linting",
    "jsonSchemaHosting": "JSON Schema Hosting"
  },
  "gettingStarted": {
    "title": "Swagger Editor",
    "description": "Welcome to the Scalar API References + Swagger Editor, a Free & Open-Source tool that takes your Swagger/OAS file and generates Beautiful API references.",
    "showExample": "Show Example",
    "uploadFile": "Upload File",
    "integrations": "INTEGRATIONS",
    "theming": "THEMING",
    "features": "Features",
    "featureCustomizeTitle": "Customize",
    "featureCustomizeDescription": "Bring your typography & color palettes, or use our themes!",
    "featureTestingTitle": "Testing",
    "featureTestingDescription": "A deeply integrated Rest API Client (Also Free & Open-Source)",
    "featureSearchTitle": "Search",
    "featureSearchDescription": "Fully integrated Search (Using fuse.js)",
    "featureHostingTitle": "Hosting",
    "featureHostingDescription": "Free subdomain hosting on https://apidocumentation.com",
    "featureOpenApiTitle": "OpenAPI & Swagger",
    "featureOpenApiDescription": "Support for OpenAPI 3.1, OpenAPI 3.0, and Swagger 2.0",
    "featureCodeSamplesTitle": "Code Samples",
    "featureCodeSamplesDescription": "Code samples to show off your API in most popular languages",
    "integrationsList": {
      "fastify": "Fastify",
      "cdn": "CDN",
      "vue": "Vue",
      "react": "React"
    }
  }
}
